import { Stack, TextField, ToggleButton, Tooltip } from '@mui/material';
import type { DescalceFilterState } from './descalceFilters';

interface DescalceFilterBarProps {
  filters: DescalceFilterState;
  onChange: (next: DescalceFilterState) => void;
}

const toggleSx = { fontSize: '0.65rem', py: 0.25, px: 1 };

export const DescalceFilterBar = ({ filters, onChange }: DescalceFilterBarProps) => {
  const set = (patch: Partial<DescalceFilterState>) =>
    onChange({ ...filters, ...patch });

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      flexWrap="wrap"
      sx={{ mb: 1, rowGap: 1 }}
    >
      <TextField
        size="small"
        placeholder="Search group / market…"
        value={filters.search}
        onChange={e => set({ search: e.target.value })}
        sx={{
          width: 220,
          '& .MuiOutlinedInput-root': { fontSize: '0.75rem', height: 28 },
          '& .MuiOutlinedInput-input': { py: 0.5, px: 1 }
        }}
        inputProps={{ 'aria-label': 'Search by group or market' }}
      />
      <TextField
        size="small"
        type="number"
        label="Min descalce"
        value={filters.minDescalce}
        onChange={e => set({ minDescalce: Number(e.target.value) || 0 })}
        sx={{
          width: 130,
          '& .MuiOutlinedInput-root': { fontSize: '0.75rem', height: 28 }
        }}
        inputProps={{ step: 0.5, min: 0, 'aria-label': 'Minimum descalce' }}
      />
      <Tooltip title="Only rows whose group has pods desired ON">
        <ToggleButton
          size="small"
          value="onlyGroupsOn"
          selected={filters.onlyGroupsOn}
          onChange={() => set({ onlyGroupsOn: !filters.onlyGroupsOn })}
          sx={toggleSx}
        >
          groups ON
        </ToggleButton>
      </Tooltip>
      <Tooltip title="Hide rows where one leg already resolved at its venue — Kalshi settled it, or Polymarket flagged it redeemable. Off by default: resolving marks that one side is cash now, it never means the imbalance is zero, so a row hidden here may still hold a real residual.">
        <ToggleButton
          size="small"
          value="hideResolving"
          selected={filters.hideResolving}
          onChange={() => set({ hideResolving: !filters.hideResolving })}
          sx={toggleSx}
        >
          hide settled
        </ToggleButton>
      </Tooltip>
      <Tooltip title="Only PROD-account rows">
        <ToggleButton
          size="small"
          value="onlyProd"
          selected={filters.onlyProd}
          onChange={() => set({ onlyProd: !filters.onlyProd, onlyTest: false })}
          sx={toggleSx}
        >
          only prod
        </ToggleButton>
      </Tooltip>
      <Tooltip title="Only TEST-account rows">
        <ToggleButton
          size="small"
          value="onlyTest"
          selected={filters.onlyTest}
          onChange={() => set({ onlyTest: !filters.onlyTest, onlyProd: false })}
          sx={toggleSx}
        >
          only test
        </ToggleButton>
      </Tooltip>
      <Tooltip title="Only rows where the engine belief disagrees with the venue read">
        <ToggleButton
          size="small"
          value="onlyDivergence"
          selected={filters.onlyDivergence}
          onChange={() => set({ onlyDivergence: !filters.onlyDivergence })}
          sx={toggleSx}
        >
          divergence only
        </ToggleButton>
      </Tooltip>
    </Stack>
  );
};
